<label class="label" translate>agent-verify-biometrics.component.learner-input</label>
<progress
  class="progress control"
  [value]="typed"
  [max]="length"
  [ngClass]="{ 'is-success': verified, 'is-failure': failed }"
></progress>
